import { render } from "./RegisterUser.vue?vue&type=template&id=9b711536"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__